export const LISTE = {
  title: 'Liste des factures',
  breadcrumb: {
    liste: 'Liste des factures',
  },
  actions: {
    add: 'Nouvelle facture',
  },
  table: {
    code: 'Facture n°',
    dateDevisCommande: 'Date',
    fournisseur: 'Fournisseur',
    sousType: 'Type',
    etat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
    montantRegle: 'Montant réglé',
  },
  filtre: {
    etat: 'Etat(s)',
    fournisseur: 'Fournisseur(s)',
    code: 'Code',
    dateDevisCommande: 'Date facture',
    agence: 'Agence(s)',
  },
};

export const DETAIL = {
  title: 'Détail facture n° {code}',
  titleAvoir: 'Détail avoir n° {code}',
  toFinalBillTitle: 'Enregistrement définitif de la facture d\'achat {code}',
  toFinalBillText: 'Afin de garantir l\'inaltérabilité et la sécurisation de vos données, vous ne pourrez plus modifier cette facture d\'achat.',
  breadcrumb: {
    liste: 'Liste des factures',
    title: 'Détail facture',
    titleAvoir: 'Détail avoir',
  },
  tabs: {
    informationsTab: 'Informations',
    ecrituresComptablesTab: 'Ecriture comptable',
    rapprochement: 'Rapprochement',
  },
  actions: {
    generateEcriture: 'MAJ Ecriture',
    draft: 'Repasser en brouillon',
    avoir: 'Créer un avoir',
    toDraftBill: 'Repasser en brouillon',
    amend: 'Corriger la facture d\'achat',
  },
  popUpPrevention: {
    toDraftBillTitle: 'Passage en brouillon de la facture {code}',
    toDraftBillText: 'Toutes les modifications sur la facture seront de nouveau possible',
  },
  popUpAvoir: {
    title: 'Vous êtes sur le point d\'annuler une facture d\'achat.',
  },
  messages: {
    success: {
      generateEcriture: 'Ecriture mise à jour avec succès',
    },
  },
  anchor: {
    commande: 'Facture',
    comments: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
};

export const ADD_EDIT = {
  title: {
    add: 'Ajouter une facture',
    edit: 'Modifier la facture n°',
    addAvoir: 'Ajouter un avoir',
    editAvoir: 'Modifier l\'avoir',
  },
  breadcrumb: {
    add: 'Ajouter une facture',
    edit: 'Modifier une facture',
    addAvoir: 'Ajouter un avoir',
    editAvoir: 'Modifier l\'avoir',
    liste: 'Liste des factures',
  },
  actions: {
    save: 'Brouillon',
  },
  popUpPrevention: {
    title: 'Vous n\'avez pas associé de période à votre facture, cela va influencer le calcul des CCA pour la situation',
    subTitle: 'Souhaitez-vous continuer ?',
  },
  notifications: {
    successCreation: 'Facture créée avec succès',
    successChange: 'Facture modifiée avec succès',
  },
  tabs: {
    informationsTab: 'Facture d\'achat',
    echeancierPaiementTab: 'Echéancier de paiement',
    factureDetailTab: 'Détail facture',
    rapprochement: 'Rapprochement',
  },
  informations: {
    title: 'Facture d\'achat',
    labelIntervenant: 'Fournisseur',
  },
  messages: {
    success: {
      editFaturePayed: 'Modification de la facture réalisée avec succès.',
      sucessReinitialisationRapprochement: 'Le rapprochement à été reinitialisé avec les informations du fournisseur',
    },
    error: {
      name: {
        libelleLigneCommande: 'Libellé de la ligne',
        quantiteLigneCommande: 'Quantité de la ligne',
        prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
        remiseLigneCommande: 'Remise de la ligne',
        tauxTvaLigneCommande: 'Taux de Tva de la ligne',
      },
      leastOneProduct: 'Vous devez saisir au minimum un produit dans la facture d\'achat.',
      leastOneBailleur: 'Vous devez saisir au minimum un fournisseur dans la facture d\'achat.',
      TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de l\'achat',
      quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
      regulationModeRequired: 'Le mode de paiement est obligatoire.',
      settlementPeriodRequired: 'Le délai de paiement est obligatoire.',
      paymentDifferent: 'La somme des échéances est différente du montant total de l\'échéancier de paiement',
      dateDepense: 'Date de la facture d\'achat',
      libelleObligatoire: 'Libéllé obligatoire',
      draftToDelete: 'Impossible de supprimer la facture d\'achat {depenseBailleur} car elle n\'est pas à l\'état brouillon.',
      sumOfAmountExceedsBillsAmount: 'Le montant des rapprochements est supérieur au montant de la facture d\'achat.',
      orderShouldBeReconciliable: 'La commande d\'achat {commandeAchat} doit être à rapprocher.',
      billShouldBeReconciliable: 'La facture d\'achat doit être à rapprocher.',
      amountTooHight: 'Le montant à rapprocher pour la commande {commandeAchat} est trop important. Maximum autorisé : {maxAmount}.',
      commandeFullyReconciled: 'Le montant de la commande d\'achat {commandeAchat} est déja rapproché.',
      reconciliationDifferentProviders: 'Impossible de rapprocher des commandes d\'achat n\'appartenant pas au même fournisseur.',
      productTypeInvalide: 'Le type de produit est invalide',
      productRequired: 'Impossible de supprimer la référence d\'un produit sur une ligne',
      echeanceEnregistreForRapprochement: 'Les échéances doivent être à l\'état "Enregistrée" pour être utilisées dans le rapprochement',
      echeanceEnregistreFacturePartiellementForRapprochement: 'Les échéances doivent être à l\'état "Enregistrée" ou "Facturée Partiellement" pour être utilisées dans le rapprochement',
      positiveNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande normale positive',
      amountIncorrect: 'Si la facture d\'achat est un avoir, son montant doit être négatif ou nul.',
      agence: 'Agence',
      saveImpossible: 'Enregistrement de la facture d\'achat impossible.',
      editImpossible: 'Modification de la facture d\'achat impossible.',
    },
  },
};
